import React, { useState, useEffect } from 'react'
import { Typography, Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { cartService } from '../../models/cart/service'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { CartItem } from '../../models/cart/cart'
import { ShoppingBag } from '../../assets/icons/ShoppingBag';

export const MobileFavoriteItem = (props: any) => {
    const { item, redirect, onRemove, onMoveToCart, translations, onUpdateCart } = props
    const [qty, setQty] = useState(1)
    const [initial, setInitial] = useState(true)
    const classes = useStyles();

    useEffect(() => {
        if (!initial) {
            cartService.create({ ...item, quantity: qty }).then((r: any) => {
                onUpdateCart(r)
            })
        }
    }, [qty, initial])

    useEffect(() => {
        if (item.quantity) {
            setQty(item.quantity)
        }
    }, [item])

    const onRedirect = (item: CartItem) => {
        redirect(`/product/${item.product.id}`)
    }
    return <Box style={{ flexDirection: 'column', display: 'flex', height: 140, minWidth: '100%' }}>

        <Box className={classes.mainRoot} onClick={() => onRedirect(item)}>
            <Box
                className={classes.column}
                style={{ width: '20%' }} onClick={() => onRedirect(item)}>
                <img src={item?.product?.mainImage} style={{ width: '100%' }} />
            </Box>
            <Box
                className={classes.column}
                style={{
                    width: '60%',
                    alignItems: 'flex-start',
                }} onClick={() => onRedirect(item)}>
                <Typography component="h4" variant="subtitle1" style={{ fontWeight: 'bold', fontSize: 17 }}>{item?.product?.brand.title}</Typography>
                <Typography component="h4" variant="subtitle1" style={{ fontWeight: '400', fontSize: 15 }}>{item?.product?.name}</Typography>
            </Box>
            <Box
                className={classes.column}
                style={{
                    width: '20%'
                }} onClick={() => onRedirect(item)}>
                <Typography component="h4" variant="subtitle2" style={{ fontWeight: '600', fontSize: 18 }}>
                    {item?.product?.specialPrice}  ₾
                </Typography>
            </Box>
        </Box>
        <Box className={classes.icon} onClick={() => onMoveToCart(item)}>
            <Box className={classes.row} style={{ alignItems: 'flex-start', justifyContent: 'flex-start' }}
                onClick={() => {

                }}>
                <Box sx={{paddingLeft: .4}}>
                    <ShoppingBag width={22} height={30} />

                </Box>
                <Typography component="h4" variant="subtitle2" style={{ fontWeight: '600', fontSize: 15, marginLeft: 10 }}>
                    {translations?.move_to_cart}
                </Typography>
            </Box>
        </Box>
        <Box className={classes.icon} onClick={() => onRemove(item)}>
            <Box className={classes.row} style={{ alignItems: 'flex-start', justifyContent: 'flex-start' }}
                onClick={() => {
                    onRemove(item)
                }}>
                <DeleteOutlineIcon sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                        color: 'red'
                    }
                }} />
                <Typography component="h4" variant="subtitle2" style={{ fontWeight: '600', fontSize: 15, marginLeft: 10 }}>
                    {translations?.delete}
                </Typography>
            </Box>
        </Box>

    </Box>
}
const useStyles = makeStyles({
    mainRoot: {
        flexDirection: 'row',
        width: '100%',
        display: 'flex',
        cursor: 'pointer',
    },
    row: {
        flexDirection: 'row',
        width: '100%',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
    },
    column: {
        flexDirection: 'column',
        width: '20%',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        flexDirection: 'row',
        width: '100%',
        cursor: 'pointer',
        paddingLeft: 25,
        paddingTop: 7,
    }

});
